export const lightColors = {
  // Brand & Principals
  LandingPage_Background: "#EAEEF5", // Match WebBooking.js
  LandingPage_Description: "#475569", // Slate 600

  // Buttons & Actions
  Button_Primary: "#d4af37", // Amber 500
  Button_Secondary: "#0F172A", // Slate 900
  Action_Button_Back: "#E0E7FF", // Indigo 100

  // Headers & Text
  Header_Background: "#FFFFFF",
  Header_Content: "#1E293B", // Slate 800
  Header: "#d4af37",//Amber 500 (Primary Brand)
  Header_Text: "#FFFFFF",
  Header_Text_back: "#334155", // Slate 700

  // Basics (Dynamic Surfaces)
  Black: "#0F172A",
  White: "#FFFFFF",
  WHITE: "#FFFFFF",
  BLACK: "#000000",
  TRANSPARENT: "transparent",

  // Static (Always Literal)
  ST_WHITE: "#FFFFFF",
  ST_BLACK: "#000000",

  // Status & Feedback
  GREEN: "#5a917e", // Emerald 500
  RED: "#EF4444", // Red 500
  YELLOW: "#d4af37", // Amber 500
  VIOLET: "#574d73", // Violet 500
  BLUE: "#3B82F6", // Blue 500
  ORANGE: "#F59E0B", // Amber 500

  // Cards & Surfaces
  CAR_BOX_EVEN: "#F1F5F9", // Slate 100
  CAR_BOX_ODD: "#FFFFFF",
  CARD_LABEL: "#64748B", // Slate 500
  CARD_DETAIL: "#F8FAFC", // Slate 50

  // Dashboard Specific
  WALLET_CARD: "#1E293B", // Slate 800 (Dark Card)
  WALLET_CARD_SHADOW: "#CBD5E1", // Slate 300

  // Tables
  Table_Header: "#CBD5E1", // Slate 300
  ROW_SELECTED: "#F1F5F9", // Slate 100
  TABLE_BORDER: "#E2E8F0", // Slate 200

  // Alerts
  ALERT_BUTTON_GOTO_COLOR: "#DBEAFE", // Blue 100
  ALERT_BUTTON_CLOSE_COLOR: "#FEE2E2", // Red 100

  // Shadows
  SHADOW_LIGHT: "#E2E8F0", // Slate 200
  SHADOW: "#94A3B8", // Slate 400
  SHADOW_ADAPTIVE: "rgba(0,0,0,0.1)",

  // Legacy / Specific Mappings
  TAXIPRIMARY: "#5e646f",
  TAXISECONDORY: "#F1F5F9",
  DELIVERYPRIMARY: "#d4af37", // Amber 500
  DELIVERYSECONDORY: "#FFF7ED",
  BIDTAXIPRIMARY: "#0F766E", // Teal 700
  BIDTAXISECONDORY: "#F0FDFA",

  STATUS_COMPLETE: "#10B981",
  STATUS_CANCELED: "#EF4444",
  STATUS_PENDING: "#F59E0B", // Amber 500

  FACEBOOK_COLOR: "#1877F2",

  // Utility Colors (for modern components)
  BORDER: "#E2E8F0", // Same as TABLE_BORDER
  GREY: {
    default: "#64748B", // Slate 500
    icon: "#94A3B8", // Slate 400
  },

  // Sidebar Specific (NEW)
  Sidebar_Background: "#FFFFFF",
  Sidebar_Content: "#1E293B",
};

export const darkColors = {
  // Brand & Principals
  LandingPage_Background: "#121214", // Match WebBooking.js
  LandingPage_Description: "#94A3B8", // Slate 400

  // Buttons & Actions
  Button_Primary: "#d4af37",//Amber 500
  Button_Secondary: "#FFFFFF",
  Action_Button_back: "#1E293B", // Slate 800

  // Headers & Text
  Header_Background: "#1E293B",
  Header_Content: "#F8FAFC", // Slate 50
  Header: "#d4af37",//Amber 500 (Primary Brand)
  Header_Text: "#FFFFFF",
  Header_Text_back: "#F1F5F9",

  // Basics (Dynamic Surfaces)
  Black: "#FFFFFF",
  White: "#1e293b", // Dark Card Background
  WHITE: "#1e293b", // Dark Card Background
  BLACK: "#F8FAFC", // Near-white
  TRANSPARENT: "transparent",

  // Static (Always Literal)
  ST_WHITE: "#FFFFFF",
  ST_BLACK: "#000000",

  // Status & Feedback
  GREEN: "#5a917e",
  RED: "#F87171",
  YELLOW: "#d4af37",// Amber 500
  VIOLET: "#574d73",
  BLUE: "#60A5FA",
  ORANGE: "#F59E0B", // Amber 500

  // Cards & Surfaces
  CAR_BOX_EVEN: "#1E293B",
  CAR_BOX_ODD: "#334155",
  CARD_LABEL: "#94A3B8",
  CARD_DETAIL: "#1E293B",

  // Dashboard Specific
  WALLET_CARD: "#334155",
  WALLET_CARD_SHADOW: "#000000",

  // Tables
  Table_Header: "#475569",
  ROW_SELECTED: "#334155",
  TABLE_BORDER: "#334155",

  // Alerts
  ALERT_BUTTON_GOTO_COLOR: "#1E3A8A",
  ALERT_BUTTON_CLOSE_COLOR: "#7F1D1D",

  // Shadows
  SHADOW_LIGHT: "#000000",
  SHADOW: "#000000",
  SHADOW_ADAPTIVE: "rgba(0,0,0,0.4)",

  // Legacy (MODIFIED for Sidebar visibility)
  TAXIPRIMARY: "#1E293B", // Dark Sidebar background
  TAXISECONDORY: "#334155", // Hover/Selected state
  DELIVERYPRIMARY: "#F59E0B", // Amber 500
  DELIVERYSECONDORY: "#2A1F18",
  BIDTAXIPRIMARY: "#14B8A6",
  BIDTAXISECONDORY: "#132A26",

  STATUS_COMPLETE: "#34D399",
  STATUS_CANCELED: "#F87171",
  STATUS_PENDING: "#F59E0B", // Amber 500

  FACEBOOK_COLOR: "#1877F2",

  // Utility Colors (for modern components)
  BORDER: "#334155", // Same as TABLE_BORDER
  GREY: {
    default: "#94A3B8", // Slate 400
    icon: "#64748B", // Slate 500
  },

  // Sidebar Specific (NEW)
  Sidebar_Background: "#1E293B",
  Sidebar_Content: "#FFFFFF",
};

// Helper to return CSS variable name for a color key
const getThemeVar = (key) => `var(--${key})`;

// Proxy to intercept color lookups and return the CSS variable reference
export const colors = new Proxy(lightColors, {
  get(target, prop) {
    // Handle Symbol access (e.g. Symbol.toPrimitive, toString, etc.)
    if (typeof prop === "symbol") {
      return target[prop];
    }

    if (prop in target) {
      if (typeof target[prop] === "object" && target[prop] !== null) {
        return new Proxy(target[prop], {
          get(subTarget, subProp) {
            if (typeof subProp === "symbol") {
              if (subProp === Symbol.toPrimitive) {
                return (_hint) => `var(--${prop}-default)`;
              }
              return subTarget[subProp];
            }
            if (subProp === "toString") return () => `var(--${prop}-default)`;
            if (subProp === "valueOf") return () => `var(--${prop}-default)`;
            return `var(--${prop}-${subProp})`;
          },
        });
      }
      return getThemeVar(prop);
    }
    return target[prop];
  },
});
